import React, { Component } from "react";
import { VideoPreview } from "./VideoPlayer";
import "./VideoPlayer.css"; // Custom CSS (provided earlier)

class StreamPlayer extends Component {
  retryTimeoutRef = null;

  state = {
    streamUrl: null,
    isLoading: true,
    error: null,
    retryCount: 0,
    fatalError: false
  };

  maxRetries = 3;

  componentDidMount() {
    const roomId = this.getRoomIdFromURL();
    if (roomId) {
      this.fetchStreamUrl(roomId);
    } else {
      this.setState({
        error: "No room ID found in URL",
        isLoading: false
      });
    }
  }

  componentWillUnmount() {
    if (this.retryTimeoutRef) {
      clearTimeout(this.retryTimeoutRef);
    }
  }

  getRoomIdFromURL = () => {
    // const params = new URLSearchParams(window.location.search);
    // const roomParam = params.get("room");
    // if (!roomParam) return null;
    // return roomParam.split("-")[0];

    return this.props.location?.state.instructor_id
  };

  fetchStreamUrl = async (roomId) => {
    try {
      const res = await fetch(
        `https://apibeta.iqra-live.com/api/v2/instructor/stream-url/${roomId}?t=${Date.now()}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Cache-Control": "no-cache"
          }
        }
      );

      if (!res.ok) {
        throw new Error(`Failed: ${res.status}`);
      }

      const data = await res.json();

      if (data?.stream_url) {
        let streamUrl = data.stream_url;

        if (window.location.protocol === "https:" && streamUrl.startsWith("http:")) {
          streamUrl = streamUrl.replace("http:", "https:");
        }

        this.setState({
          streamUrl,
          isLoading: false,
          error: null,
          retryCount: 0,
          fatalError: false
        });
      } else {
        throw new Error("No stream URL found");
      }
    } catch (err) {
      this.setState({
        error: err.message,
        isLoading: false
      });
    }
  };

  retryConnection = () => {
    this.setState(
      {
        isLoading: true,
        error: null,
        retryCount: 0,
        fatalError: false
      },
      () => {
        const roomId = this.getRoomIdFromURL();
        if (roomId) {
          this.fetchStreamUrl(roomId);
        }
      }
    );
  };

  render() {
    const { isLoading, error, streamUrl } = this.state;

   return (
    <div className="stream-player-container">
      <div className="player-wrapper">

        {/* Loading */}
        {isLoading && (
          <div className="loading-overlay">
            <div className="spinner"></div>
            <p>Loading stream...</p>
          </div>
        )}

        {/* Error */}
        {error && (
          <div className="error-overlay">
            <p className="error-message">{error}</p>
            <button className="retry-button" onClick={this.retryConnection}>
              Try Again
            </button>
          </div>
        )}

        {/* ✅ VideoPreview handles EVERYTHING else */}
        {!isLoading && !error && streamUrl && (
          <VideoPreview src={streamUrl} />
        )}
      </div>
    </div>
  );  }
}

export default StreamPlayer;